import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownWideShort } from "@fortawesome/free-solid-svg-icons";
// import {  } from "./FilterArrowDown.styles";

const FilterArrowDown = () => {
    return (
        <FontAwesomeIcon icon={faArrowDownWideShort} />
    )
}

export default FilterArrowDown;